var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Order, Property 2=ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007040"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4585",
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1630",
    d: "M8.80054 9.2V4H15.2005V9.2C15.2005 10.024 14.2598 10.4944 13.6005 10L12.6005 9.25C12.245 8.98333 11.7561 8.98333 11.4005 9.25L10.4005 10C9.7413 10.4944 8.80054 10.024 8.80054 9.2Z",
    stroke: "#68A14B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOrder);
export default __webpack_public_path__ + "static/media/selected-order.8da65ae612ddbc95a4321260b536e603.svg";
export { ForwardRef as ReactComponent };